var map = {
	"./aparthotelclub/ic_tag_star.png": 36834,
	"./beachful/ic_tag_star.png": 68225,
	"./castlepedia/ic_tag_star.png": 8132,
	"./cocktayl/ic_tag_star.png": 94182,
	"./ic_tag_star.png": 18778,
	"./luxresortclub/ic_tag_star.png": 53940,
	"./parkful/ic_tag_star.png": 44327,
	"./prefabworld/ic_tag_star.png": 24629,
	"./rooftopclub/ic_tag_star.png": 67033,
	"./spaclub/ic_tag_star.png": 62176,
	"./worldcasino/ic_tag_star.png": 8561,
	"./zoopedia/ic_tag_star.png": 48579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99123;